/** jQuery JavaScript for powerbi functionality **/
(function (powerbiembedded, $) {

    /* Embed a power BI board */
    powerbiembedded.embedBoard = function(accessToken, embedUrl, embedBoardId, boardType, dataSetId) {
        // Get models. models contains enums that can be used.
        var models = window['powerbi-client'].models;

        // Embed configuration used to describe the what and how to embed.
        var config = {
            type: boardType.toLowerCase(),
            tokenType: models.TokenType.Embed,
            accessToken: accessToken,
            embedUrl: embedUrl,
            id: embedBoardId,
            settings: {
                extensions: {
                    commands: [{
                        name: "clear_all_filters",
                        title: "Clear all filters",
                        extend: {
                            visualContextMenu: {
                                title: "Clear all filters",
                            },
                            visualOptionsMenu: {
                                title: "Clear all filters",
                            }
                        }
                    },
                    {
                        name: "clear_filters",
                        title: "Clear filters",
                        extend: {
                            visualContextMenu: {
                                title: "Clear filters",
                            },
                            visualOptionsMenu: {
                                title: "Clear filters",
                            }
                        }
                    }]
                }
            }
        };

        if (boardType === "Report" && dataSetId) {
            var extendConfig = {
                datasetBinding: {
                    datasetId: dataSetId,
                }
            };

            $.extend(true, config, extendConfig);
        }

        // Get a reference to the embedded board HTML element
        var boardContainer = $('#boardContainer')[0];

        // Embed the board and display it within the div container.
        var report = powerbi.embed(boardContainer, config);

        report.on("commandTriggered", async function (command, a, b, c, d, e, f, g) {
            if (command.detail.command !== "clear_filters")
                return;

            var pages = await report.getPages();
            for (var i = 0; i < pages.length; i++) {
                if (pages[i].name === command.detail.page.name) {
                    await pages[i].updateFilters(models.FiltersOperations.RemoveAll);
                }
                var visuals = await pages[i].getVisuals();
                for (var j = 0; j < visuals.length; j++) {
                    if (visuals[j].name === command.detail.visual.name) {
                        await visuals[j].updateFilters(models.FiltersOperations.RemoveAll);
                    }
                }
            }
        });

        report.on("commandTriggered", async function (command, a, b, c, d, e, f, g) {
            if (command.detail.command !== "clear_all_filters")
                return;

            await report.updateFilters(models.FiltersOperations.RemoveAll);
            var pages = await report.getPages();
            for (var i = 0; i < pages.length; i++) {
                await pages[i].updateFilters(models.FiltersOperations.RemoveAll);
                var visuals = await pages[i].getVisuals();
                for (var j = 0; j < visuals.length; j++) {
                    await visuals[j].updateFilters(models.FiltersOperations.RemoveAll);
                }
            }
        });

        // Set height and width
        $('#boardContainer').height($(document).height());
        $('#boardContainer').width($(document).width());
        $('#boardContainer').parent().parent().parent().css("padding", 0);
    }

}(window.powerbiembedded = window.powerbiembedded || {}, jQuery));
